var homeHandler = {
  resizeTimer: null,
  adjustIntro: function() {
    if (Foundation.MediaQuery.is('medium')) {
      var $leftContent = $('.home-hero .left-content');
      var $rightContent = $('.home-hero .right-content');
      $leftContent.height('auto');
      $rightContent.height('auto');
      var maxHeight = Math.max($leftContent.outerHeight(),$rightContent.outerHeight());
      $leftContent.height(maxHeight);
      $rightContent.height(maxHeight);  
    }
  }
}

jQuery(document).ready(function($) {
  // samakan tinggi left dan right content di intro
  homeHandler.adjustIntro();
  $(window).on('resize', function() {
    clearTimeout(homeHandler.resizeTimer);
    homeHandler.resizeTimer = setTimeout(function() {
      homeHandler.adjustIntro();
    }, 10);
  })
});
